<template>
  <div>
    <div class="p16">
      <div
        class="hide-shimmer-text shimmer-container rounded width100"
        :style="{ height: '50px' }"
      >
        random
      </div>
      <div
        class="hide-shimmer-text shimmer-container rounded width50 mt40"
        :style="{ height: '20px' }"
      >
        random
      </div>
      <div
        class="rounded w100 mb8 border-around p5 br8 mt16"
        :style="{ background: '#F4F4F4' }"
      >
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width80">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
      </div>
      <div
        class="hide-shimmer-text shimmer-container rounded width50 mt40"
        :style="{ height: '20px' }"
      >
        random
      </div>
      <div
        class="rounded w100 mb8 border-around p5 br8 mt16"
        :style="{ background: '#F4F4F4' }"
      >
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width80">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
      </div>
      <div
        class="rounded w100 mb8 border-around p5 br8 mt16"
        :style="{ background: '#F4F4F4' }"
      >
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width80">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
      </div>
      <div
        class="rounded w100 mb8 border-around p5 br8 mt16"
        :style="{ background: '#F4F4F4' }"
      >
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width80">
            random tip title text
          </div>
        </ul>
        <ul class="d-flex justify-content-between w100 mb8 p5 br8">
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width20">
            random
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OfferListingPageShimmer",
};
</script>
